export default "__VITE_ASSET__C2F35HP9__"